var ApiResult = /** @class */ (function () {
    function ApiResult(status, data, errors) {
        this.status = status;
        this.data = data;
        this.errors = errors;
    }
    Object.defineProperty(ApiResult.prototype, "ok", {
        /**
         * the response was successful (status in the range 200-299) or not.
         * https://developer.mozilla.org/en-US/docs/Web/API/Response/ok
         */
        get: function () {
            return this.status >= 200 && this.status <= 299;
        },
        enumerable: false,
        configurable: true
    });
    ApiResult.prototype.setTotalFromString = function (total) {
        if (!total) {
            return;
        }
        this.total = parseInt(total);
    };
    return ApiResult;
}());
export default ApiResult;
//# sourceMappingURL=ApiResult.js.map